module.exports = __webpack_public_path__ + "static/featuredblock1-4b3a03931cfd0097c6a19cbf08cc557a.jpg";